export function mergeFilters(filters: readonly (string | undefined)[]): string | undefined {
    const present = filters.filter((f): f is string => Boolean(f));
    if (present.length === 0) {
        return undefined;
    }
    if (present.length === 1) {
        return present[0];
    }
    return present.map(f => `(${f})`).join(" and ");
}
